import { createContext } from 'react';
import { PreparedPaymentCustomer } from './PaymentSubmissionContext';

export interface CompletedEsignDetails {
  fieldName: string;
  leadId: string;
  verificationId: string;
  // The CRM lead can accumulate multiple signed documents over time (across forms/
  // resubmissions) - docId pins the response to the specific MITC doc signed here.
  docId?: string;
}

export type EsignFieldStatus = 'idle' | 'processing' | 'done' | 'error';

export interface EsignFieldStatusState {
  status: EsignFieldStatus;
  errorMessage: string;
}

export const EsignSubmissionContext = createContext<
  {
    prepareLead: () => Promise<PreparedPaymentCustomer>;
    completeEsign: (
      fieldName: string,
      esign: CompletedEsignDetails,
    ) => Promise<void>;
    getEsignStatus: (
      fieldName: string,
    ) => EsignFieldStatusState | undefined;
    setEsignStatus: (
      fieldName: string,
      state: EsignFieldStatusState,
    ) => void;
  } | null
>(null);
